import { defineMessages } from 'react-intl';

// Hard-coded requirements for each vertical - simple map from vertical to array of message keys
export const verticalRequirements = {
  // AB Vertical
  AB: ['abWeeklyBqRequirement', 'genericDoubleMonthlyRequirement'],
  // Consumer Vertical
  Consumer: [
    'consumerWeeklyBqRequirement',
    'consumerWeeklyNhRequirement',
    'genericSingleMonthlyRequirement',
  ],
  // CAP Vertical
  CAP: [
    'capWeeklyBqRequirement',
    'capWeeklyNhRequirement',
    'genericSingleMonthlyRequirement',
  ],
  // D2 Vertical
  D2AS: [
    'd2WeeklyBqRequirement',
    'd2WeeklyNhRequirement',
    'genericDoubleMonthlyRequirement',
  ],
  // SDS Vertical
  SDS: ['sdsWeeklyBqRequirement', 'genericTripleMonthlyRequirement'],
  // Total Vertical
  Total: [
    'totalMonthlyBqRequirement',
    'totalMonthlyNhRequirement',
    'genericSingleMonthlyRequirement',
  ],
};

export const coachingModalMessages = defineMessages({
  // Modal titles
  weeklyCoaching: {
    id: 'cs_perfportal_cstats_weekly_coaching',
    defaultMessage: 'Weekly Coaching',
  },
  monthlyCoaching: {
    id: 'cs_perfportal_cstats_monthly_coaching',
    defaultMessage: 'Monthly Coaching',
  },

  // Understanding coaching totals section
  understandingCoachingTotals: {
    id: 'cs_perfportal_cstats_understanding_coaching_totals',
    defaultMessage: 'Understanding coaching totals',
  },
  coachingTotalsDescription: {
    id: 'cs_perfportal_cstats_coaching_totals_description',
    defaultMessage:
      'The # remaining at the top of the card displays the total number of remaining coachings you need to deliver in order to achieve 100% coachings for all associates. Below the line is a breakdown of all the associates you manage that still need at least one coaching. Each associate needs to receive the minimum number of coachings defined in the required coachings section below in order to achieve 100% coachings.',
  },
  coachingTotalsExample: {
    id: 'cs_perfportal_cstats_coaching_totals_example',
    defaultMessage:
      'Examples where you have 2 associates that each require 2 coachings (Applies to both monthly and weekly coaching cards):',
  },
  coachingTotalsExample1: {
    id: 'cs_perfportal_cstats_coaching_totals_example1',
    defaultMessage:
      '1. If you have coached each associate once, the # remaining on the top of the card will be 2, and both will be the associates list when the card is expanded.',
  },
  coachingTotalsExample2: {
    id: 'cs_perfportal_cstats_coaching_totals_example2',
    defaultMessage:
      '2. If you have coached one associate twice and the other 0 times, the # remaining on the top of the card will be 2, and the associates with 0 coachings will be in the list when the card is expanded.',
  },
  coachingTotalsExample3: {
    id: 'cs_perfportal_cstats_coaching_totals_example3',
    defaultMessage:
      '3. If you have coached one associate 10 times and the other 0 times, the # remaining on the top of the card will be 2, and the associates with 0 coachings will be in the list when the card is expanded.',
  },

  // Understanding weekly nature section
  understandingWeeklyNature: {
    id: 'cs_perfportal_cstats_understanding_weekly_nature',
    defaultMessage: 'Understanding weekly nature of coaching stats',
  },
  weeklyNatureDescription: {
    id: 'cs_perfportal_cstats_weekly_nature_description',
    defaultMessage:
      'Every Sunday, Inspire updates the coaching stats reports with changes to reporting structures. If an employee moves to a new team, or is terminated in the middle of the week, this will be updated on the upcoming Sunday and reflected in next weeks coaching stats reports.',
  },

  // Vertical required coachings section
  verticalRequiredCoachings: {
    id: 'cs_perfportal_cstats_vertical_required_coachings',
    defaultMessage: '{vertical} required coachings',
  },
  requiredCoachingsDescription: {
    id: 'cs_perfportal_cstats_required_coachings_description',
    defaultMessage:
      'Different amounts of coaching per associate may vary based on factors such as vertical, outliers, or new hire status. In the {vertical} vertical the following is required:',
  },
  // AB Vertical Requirements
  abWeeklyBqRequirement: {
    id: 'cs_perfportal_cstats_ab_weekly_bq_requirement',
    defaultMessage: '1 coaching per week for Bottom Quartile associates',
  },

  // Consumer Vertical Requirements
  consumerWeeklyBqRequirement: {
    id: 'cs_perfportal_cstats_consumer_weekly_bq_requirement',
    defaultMessage: '1 coaching per week for Bottom Quartile associates',
  },
  consumerWeeklyNhRequirement: {
    id: 'cs_perfportal_cstats_consumer_weekly_nh_requirement',
    defaultMessage: '1 coaching per week for New Hire associates',
  },

  // CAP Vertical Requirements
  capWeeklyBqRequirement: {
    id: 'cs_perfportal_cstats_cap_weekly_bq_requirement',
    defaultMessage: '1 coaching per week for Bottom Quartile associates',
  },
  capWeeklyNhRequirement: {
    id: 'cs_perfportal_cstats_cap_weekly_nh_requirement',
    defaultMessage: '1 coaching per week for New Hire associates',
  },

  // D2 Vertical Requirements
  d2WeeklyBqRequirement: {
    id: 'cs_perfportal_cstats_d2_weekly_bq_requirement',
    defaultMessage: '1 coaching per week for Bottom Quartile associates',
  },
  d2WeeklyNhRequirement: {
    id: 'cs_perfportal_cstats_d2_weekly_nh_requirement',
    defaultMessage: '1 coaching per week for New Hire associates',
  },

  // SDS Vertical Requirements
  sdsWeeklyBqRequirement: {
    id: 'cs_perfportal_cstats_sds_weekly_bq_requirement',
    defaultMessage:
      '1 coaching per week for Bottom Quartile associates (CCX-OS B2B only)',
  },
  sdsMonthlyNhRequirement: {
    id: 'cs_perfportal_cstats_sds_monthly_nh_requirement',
    defaultMessage: '3 coachings per month for New Hire associates',
  },

  // Total Vertical Requirements
  totalMonthlyBqRequirement: {
    id: 'cs_perfportal_cstats_total_monthly_bq_requirement',
    defaultMessage: '1 coaching per month for Bottom Quartile associates',
  },
  totalMonthlyNhRequirement: {
    id: 'cs_perfportal_cstats_total_monthly_nh_requirement',
    defaultMessage: '1 coaching per month for New Hire associates',
  },

  // Generic Vertical Requirements messaging
  genericSingleMonthlyRequirement: {
    id: 'cs_perfportal_cstats_generic_single_requirement',
    defaultMessage: '1 coaching per month for all other associates',
  },
  genericDoubleMonthlyRequirement: {
    id: 'cs_perfportal_cstats_generic_double_requirement',
    defaultMessage: '2 coachings per month for all other associates',
  },
  genericTripleMonthlyRequirement: {
    id: 'cs_perfportal_cstats_generic_triple_requirement',
    defaultMessage: '3 coachings per month for all other associates',
  },

  // Bottom quartile delay section
  bottomQuartileDelay: {
    id: 'cs_perfportal_cstats_bottom_quartile_delay',
    defaultMessage: 'Bottom quartile delay',
  },
  bottomQuartileDelayDescription: {
    id: 'cs_perfportal_cstats_bottom_quartile_delay_description',
    defaultMessage:
      'Bottom quartile results are published on the first of each month. If the current calendar week overlaps two months, you may notice a difference in the number of associates on the Metrics: Bottom Quartile Associates page and the coaching stats cards.',
  },

  // Inactive associates section
  inactiveAssociates: {
    id: 'cs_perfportal_cstats_inactive_associates',
    defaultMessage: '({count}) Associates who are inactive',
  },
  inactiveAssociatesDescription: {
    id: 'cs_perfportal_cstats_inactive_associates_description',
    defaultMessage:
      'TMs are not required to coach inactive associates. The following associates are inactive:',
  },

  // Moved team associates section
  movedTeamAssociates: {
    id: 'cs_perfportal_cstats_moved_associates',
    defaultMessage: '({count}) Associates who moved teams',
  },
  movedTeamAssociatesDescription: {
    id: 'cs_perfportal_cstats_moved_associates_description',
    defaultMessage:
      'TMs are required to complete all coachings for associates before they move to a new team. If you have completed all coachings for your current direct reports, but are unable to achieve 100% coaching, this is because a direct report has moved to a new team before you completed all their coachings.',
  },

  // Final note section
  finalNote: {
    id: 'cs_perfportal_cstats_final_note',
    defaultMessage: 'Final Note',
  },
  finalNoteDescription: {
    id: 'cs_perfportal_cstats_final_note_description',
    defaultMessage:
      'Our team is unable to adjust the rules or classification for any associate, and will not be responding to related tickets.',
  },

  // Button
  confirm: {
    id: 'cs_perfportal_confirm',
    defaultMessage: 'Confirm',
  },
});
